import React, { useState } from "react";
import { ShieldCheck, Loader2, Copy, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";

// حساب مراجعي Meta: ينشئه/يعيد ضبطه الأدمن بضغطة، وتُعرض كلمة المرور مرة واحدة فقط
export const MetaReviewerCard = () => {
  const [busy, setBusy] = useState(false);
  const [cred, setCred] = useState(null);
  const run = async () => {
    if (cred && !window.confirm("سيتم توليد كلمة مرور جديدة وإبطال القديمة. متابعة؟")) return;
    setBusy(true);
    try { const { data } = await api.post("/admin/users/meta-reviewer"); setCred(data); toast.success("حساب المراجعين جاهز — انسخ البيانات الآن"); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const copy = (t, label) => { navigator.clipboard.writeText(t); toast.success(`تم نسخ ${label}`); };
  const block = cred ? `Website: ${cred.login_url || "https://rawajsmart.com/login"}\nLogin email: ${cred.email}\nLogin password: ${cred.password}\nValid until: ${cred.valid_until}` : "";
  return (
    <div className="glass rounded-2xl p-6" data-testid="meta-reviewer-card">
      <div className="flex items-center gap-2 mb-1"><ShieldCheck className="w-5 h-5 text-accent" /><h2 className="text-lg font-bold">حساب مراجعي Meta (App Review)</h2></div>
      <p className="text-xs text-muted-foreground mb-4">حساب تجريبي كامل المزايا لمدة سنة مع مشروع جاهز «Dandanah Café» ليختبر مراجعو Meta ربط إنستغرام والنشر. كلمة المرور تُعرض مرة واحدة فقط — انسخها في نموذج App Review.</p>
      <Button onClick={run} disabled={busy} className="gap-1 bg-accent text-accent-foreground hover:bg-accent/90" data-testid="meta-reviewer-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />}
        {cred ? "إعادة توليد كلمة المرور" : "أنشئ / جدّد حساب المراجعين"}
      </Button>
      {cred && (
        <div className="mt-4 rounded-xl border border-accent/40 bg-accent/5 p-4 text-sm space-y-2" data-testid="meta-reviewer-creds">
          <div className="flex items-center justify-between gap-2" dir="ltr"><span className="font-mono">{cred.email}</span><button onClick={() => copy(cred.email, "البريد")} className="text-accent" data-testid="copy-reviewer-email"><Copy className="w-4 h-4" /></button></div>
          <div className="flex items-center justify-between gap-2" dir="ltr"><span className="font-mono select-all">{cred.password}</span><button onClick={() => copy(cred.password, "كلمة المرور")} className="text-accent" data-testid="copy-reviewer-password"><Copy className="w-4 h-4" /></button></div>
          <div className="text-xs text-muted-foreground">صالح حتى {cred.valid_until} · باقة الاستراتيجية + سوبر رواج + 60 فيديو + 400 صورة</div>
          <Button variant="outline" size="sm" onClick={() => copy(block, "نص الدخول الكامل")} className="gap-1" data-testid="copy-reviewer-block"><Copy className="w-3.5 h-3.5" /> نسخ نص الدخول الجاهز لنموذج Meta</Button>
        </div>
      )}
    </div>
  );
};
